import {MeetingDetailsCardMeetingLinkProps} from './types';
import {useTranslation} from 'react-i18next';

import {pxToRem} from '@utils';
import {Icon, ThreeColumnCell} from '@atoms';
import {MeetingLink, MeetingLinkWrapper} from './styles';
import {useIsTeamsApp} from '@hooks';
import {meeting} from '@microsoft/teams-js';
import {getIsMicrosoft365IntegrationActive, useAppSelector} from '@lib/store';

export const MeetingDetailsCardMeetingLink = ({onlineMeetingUrl}: MeetingDetailsCardMeetingLinkProps) => {
  const {t} = useTranslation();
  const isTeamsApp = useIsTeamsApp();
  const isMicrosoft365IntegrationActive = useAppSelector(getIsMicrosoft365IntegrationActive);
  const useSeamlessJoinInTeams = isTeamsApp && isMicrosoft365IntegrationActive;

  const openInTeams = () => {
    if (useSeamlessJoinInTeams && onlineMeetingUrl?.length) {
      meeting.joinMeeting({joinWebUrl: new URL(onlineMeetingUrl)});
    }
  };

  return (
    <MeetingLinkWrapper $noUrl={!onlineMeetingUrl}>
      {onlineMeetingUrl && (
        <MeetingLink
          href={useSeamlessJoinInTeams ? undefined : onlineMeetingUrl}
          onClick={openInTeams}
          rel="noopener noreferrer"
          data-testid="organisms-eventDetails-MeetingDetailsCardMeetingLink_join-meeting-link"
          target="_blank">
          <ThreeColumnCell
            left={
              <Icon
                icon="videocamera"
                size={pxToRem(24)}
              />
            }
            middle={<p>{t('meeting:JoinOnlineMeeting')}</p>}
            padding="small"
            right={
              <Icon
                icon="caretRight"
                size={pxToRem(24)}
              />
            }
            separator={false}
          />
        </MeetingLink>
      )}
    </MeetingLinkWrapper>
  );
};
